

export const getEnv = (hostname: string): string => {
  let environment = 'unknown';
  if (hostname) {
    if (hostname.includes("localhost")) {
      environment = "local"
    } else if (
      hostname.includes("dev") ||
      hostname.includes("test") ||
      hostname.includes("preview")
    ) {
      environment = "dev"
    } else if (
      hostname.includes("stg") ||
      hostname.includes("stage")
    ) {
      environment = "stg"
    } else {
      environment = "prod"
    }
  }
  return environment;
}

export const containsValidTargetClass = (validClasses:string[], target:any) => {
  // for use in event handlers - returns true if event target has a matching class in the supplied validClasses array
  let validClick = false

  validClasses?.forEach((validClass:any) => {
    if (target && target?.contains(validClass) && validClick === false) {
      validClick = true
    }
  })
  return validClick
}
